import i18next from 'i18next';

export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

export function parseNumberInput(rawValue: string): number | undefined {
  if (rawValue.trim() === '') {
    return undefined;
  }

  const parsed: number = Number(rawValue);

  return Number.isNaN(parsed) ? undefined : parsed;
}

export function formatMinutes(value: number): string {
  return new Intl.NumberFormat(i18next.language, { maximumFractionDigits: 0 }).format(value);
}

export function formatPercentage(value: number): string {
  return new Intl.NumberFormat(i18next.language, { maximumFractionDigits: 1 }).format(value);
}

export function getVisiblePageNumbers(page: number, pageCount: number): (number | null)[] {
  const visible: number[] = Array.from(new Set([0, page - 1, page, page + 1, pageCount - 1]))
    .filter((candidate: number) => candidate >= 0 && candidate < pageCount)
    .sort((left: number, right: number) => left - right);

  const result: (number | null)[] = [];

  for (const candidate of visible) {
    const previous: number | null | undefined = result[result.length - 1];

    if (typeof previous === 'number' && candidate - previous === 2) {
      result.push(previous + 1);
    }

    if (typeof previous === 'number' && candidate - previous > 2) {
      result.push(null);
    }

    result.push(candidate);
  }

  return result;
}
